import { AlarmVideoMarker } from '@hakimo-ui/hakimo/types';
import { Button } from '@hakimo-ui/shared/ui-base';
import clsx from 'clsx';
import { ReactElement } from 'react';

const ACTIVE_MARKER_CLASS: Record<AlarmVideoMarker['type'], string> = {
  Warning: 'bg-hakimo-yellow',
  Info: 'bg-primary-400 dark:bg-primary-800',
  Error: 'bg-red-400 dark:bg-red-800',
};

export interface FaceDetectionSeekControl {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export interface Props {
  markers?: AlarmVideoMarker[];
  activeMarker?: AlarmVideoMarker;
  onTimestampClick: (timestamp: number) => void;
  timer: ReactElement;
  faceDetection?: FaceDetectionSeekControl;
}

export function AlarmVideoFooter(props: Props) {
  const { markers, activeMarker, onTimestampClick, timer, faceDetection } =
    props;

  return (
    <div className="flex items-center justify-between">
      <div className="space-x-3 px-4 py-4">
        {markers &&
          markers
            .sort((a, b) => a.timestamp - b.timestamp)
            .map((marker, idx) => {
              return (
                <span
                  key={idx}
                  className={clsx(
                    'inline-flex items-center rounded-full bg-opacity-30',
                    marker === activeMarker && ACTIVE_MARKER_CLASS[marker.type]
                  )}
                >
                  <Button
                    variant="link"
                    onClick={() => onTimestampClick(marker.timestamp)}
                  >
                    {marker.label}
                  </Button>
                </span>
              );
            })}
        {faceDetection && (
          <span
            className={clsx(
              'inline-flex items-center rounded-full bg-opacity-30',
              faceDetection.isActive && ACTIVE_MARKER_CLASS.Info
            )}
          >
            <Button variant="link" onClick={faceDetection.onClick}>
              {faceDetection.label}
            </Button>
          </span>
        )}
      </div>
      {timer}
    </div>
  );
}

export default AlarmVideoFooter;
